// extracted by mini-css-extract-plugin
module.exports = {"animationWrapper":"rivermax_animationWrapper__GVq7k"};